package com.example.mystybag.core.expected

/**
 * Result of a successful Facebook Sign-In flow returned by [signInWithFacebook].
 *
 * Unlike Google/Apple, Facebook returns an **access token** (opaque) rather than
 * an OIDC id token (JWT). Profile fields (`email`, `firstName`, `lastName`,
 * `photoUrl`) are fetched from the Graph API `/me?fields=...` endpoint
 * immediately after login by the platform-specific helper, so they are always
 * the latest values that the user agreed to share.
 *
 * `email` may be empty if the user denied the `email` permission OR if the
 * Facebook account has no verified email — in that case [WelcomeViewModel]
 * surfaces a snackbar and refuses to enroll.
 *
 * `accessToken` is currently NOT sent to the backend (the existing flow only
 * forwards `email` + profile fields), but kept here for future use (e.g. backend
 * verification via Graph API `/debug_token`).
 */
data class FacebookSignInResult(
    val email: String,
    val userId: String,
    val accessToken: String,
    val firstName: String? = null,
    val lastName: String? = null,
    val photoUrl: String? = null,
)
